import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Sandpack } from "@codesandbox/sandpack-react";
import { FiTarget } from "react-icons/fi";
import { CiCircleInfo } from "react-icons/ci";
import { Canvas } from "@react-three/fiber";
import Cube from "./Helper/Cube";
import { Stats, OrbitControls } from "@react-three/drei";
import { FaRegFaceSmileWink } from "react-icons/fa6";

function Sandpack_E2() {
    const [viewportHeight, setViewportHeight] = useState(0);


    useEffect(() => {

        const updateViewportHeight = () => {
            const heightInPixels = window.innerHeight;
            setViewportHeight(heightInPixels);
        };

        updateViewportHeight();
        // window.addEventListener("resize", updateViewportHeight);
        return () => {
            window.removeEventListener("resize", updateViewportHeight);
        };
    }, []);

    let files = {
        "/Cube.js": `
import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";

export default function Cube() {
    const MeshRef = useRef();

    useFrame(() => {
        if (!MeshRef.current) return;
        //MeshRef.current.rotation.x += 0.01;
        // MeshRef.current.rotation.y += 0.01;
    });

    return (
        <mesh ref={MeshRef}>
            <boxGeometry args={[1, 4, 0]} />
            <meshStandardMaterial color="green" />
            // use color="hotpink" 
        </mesh>
    );
}
`,
        "/App.js": `import Main from "./Main.js"
import "./main.css"
export default function App() {
            return <div className="full_container">
            <Main />
            </div>
          }`,
        "/Main.js": `import { Canvas } from "@react-three/fiber";
import Cube from "./Cube.js";
import { Stats, OrbitControls } from "@react-three/drei";

export default function Main() {
    return <>
                <Canvas>
                    <ambientLight />
                    <pointLight position={[10, 10, 10]} />
                    <Cube />
                    <OrbitControls />
                </Canvas>
        </>
}`,
        "/main.css": `canvas {
    background-color: peachpuff;
}

.full_container{
    height:50vh;
    // background-color:peachpuff;
}
* {
    box-sizing: border-box;
  }
    
html,
body,
#root {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
  
`,
    };


    return (
        <Sandpack
            className="addon"
            customSetup={{
                dependencies: {
                    "react-markdown": "latest",
                    "@react-three/fiber": "latest",
                    "@react-three/drei": "latest",
                    three: "latest",
                    "@react-three/drei": "latest"
                    // entry: "/Index.js",
                    // "@react-three/fiber": "latest",
                },
            }}
            options={{
                showLineNumbers: false, // default - true
                showInlineErrors: true, // default - false
                wrapContent: false, // default - false
                editorHeight: viewportHeight, // default - 300
                editorWidthPercentage: 50, // default - 50
                activeFile: "/Main.js",
                visibleFiles: ["/Main.js", "/main.css", "/Cube.js"],
            }}
            files={files}
            theme="dark"
            template="react"
        />
    );
}

export default Sandpack_E2;
